import { dataModel, defaults } from './dataModel';

export const richContentData = { dataModel, defaults };
